<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row">
      <div class="col-6">
        <h1>Categorias</h1>
      </div>
      <div class="col-6 text-end">
        <router-link to="/category/new">
          <button class="btn btn-primary mt-3">Adicionar Categoria</button>
        </router-link>
      </div>
    </div>
    <hr/>
    
    <app-table v-if="!loading" empty-message='nada encontrado'
    :colunas="[{ label: 'Id' }, { label: 'Nome' }, {label: 'Descrição'},{label: ''}]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.id},
          {value: item.name},
          {value: item.description}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/category/new', query: { edit: true, id: item.id } }">
          <i class="bi bi-pencil me-2"></i>Editar
        </router-link>
        <button v-show="isAdmin" @click="showModal_delete(item)" class="btn btn-sm btn-danger">
          <i class="bi bi-trash me-2"></i>Excluir
        </button>
      </template>
      </app-trow>
    </app-table>

    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Modal de Delete -->
    <div class="modal fade" id="modal_delete" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Confirmar Exclusão</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
            <p class="mt-3">Tem certeza que deseja excluir a categoria de <strong>{{ category.name }}</strong></p>
            <p class="text-muted small">Esta ação não pode ser desfeita e pode afetar o estoque.</p>
          </div>
          <div class="modal-footer">
              <button type="button" @click="closeModal" class="btn btn-secondary">Cancelar</button>
              <button type="button" @click="confirmExcluir" :disabled="deleteLoading" class="btn btn-danger">
                <span v-if="deleteLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Excluir</span>
              </button>
          </div>
        </div>  
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive } from 'vue';
import { Modal } from "bootstrap";
import { categories } from '@/models/categories';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "CategoryView",
  components: { 
    PainelLayout,
    Breadcrumb,
    AppTable, AppTrow
  },
  setup(props) {

    const toastStore = useToastStore();
    const lista = ref([]);
    const model = categories();
    let modal = '';

    var deleteLoading = ref(false);
    var loading = ref(false);

    const category = reactive({
      id: null,
      name: ''
    });

    const { isAdmin, isUser, isOpeto } = usePermissions();

    async function list() {
      loading.value = true;
      lista.value = await model.list();
      loading.value = false;
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete(item) {
      category.id = item.id;
      category.name = item.name;
      openModal('modal_delete');
    }

    function confirmExcluir() {
      deleteLoading.value = true;
      model.delet(category.id).then(() => {
        toastStore.success('Categoria excluída com sucesso.');
        closeModal();
        list();
      }).catch((error) => {
        deleteLoading.value = false;
        toastStore.error('Erro ao excluir categoria: ' + parseError(error));
      });
    }

    onMounted(() => {
      list();
    });

    return {
      list,deleteLoading,
      lista,loading,
      showModal_delete,
      category,
      closeModal,
      openModal,
      confirmExcluir,
      isAdmin,
      isUser,
      isOpeto
    }
  }
}
</script>